import { fieldTraitProgressBarOptions, textTraitDateOptions } from '../../dataGroup/traitsApi';
import { getCollectionFields } from '../../pluginComponentApi';
export const PieChartBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-pie-chart-fill"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="pie_chart">
                <img src="https://public-webconnect.s3.amazonaws.com/chart/pie.png" alt="Pie or Donut"/>
            </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-pie-chart-fill"></i>',
          projectId: projectId,
          traits: [
            {
              type: 'number',
              label: 'Width',
              name: 'chartWidth',
              changeProp: 1,
              value: 300,
              min: 100,
              step: 10,
              max: 1000,
            },
            {
              type: 'select',
              label: 'Chart Type',
              name: 'chartType',
              value: 'pie',
              changeProp: 1,
              options: [
                { id: 'pie', name: 'Pie' },
                { id: 'donut', name: 'Donut' },
              ],
            },
          ],
          script: function () {
            const chartType = '{[ chartType ]}';
            const chartWidth = '{[ chartWidth ]}';

            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';

            const chartData = {
              chartType,
              chartWidth,
            };
            if (typeof renderPieChart !== 'undefined') {
              renderPieChart(this, chartData, collectionId, finderId);
            }
          },
        },
        async init() {
          const collectionName = this.get('collectionName');
          let options = collections.map((item) => {
            return { value: item.collectionName, name: item.collectionTitle };
          });
          this.addTrait([
            {
              type: 'select',
              label: 'Collection',
              name: 'collectionName',
              changeProp: 1,
              options: options,
            },
            {
              type: 'select',
              label: 'Filter',
              name: 'finderUuid',
              changeProp: 1,
            },
          ]);
          if (collectionName) {
            const selectedCollection = collections.find(
              (collection) => collection.collectionName === collectionName,
            );
            const finderOptions = selectedCollection
              ? selectedCollection.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];
            this.getTrait('finderUuid').set({ options: finderOptions });
          }
          this.on('change:collectionName', this.handleCollectionChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collection = await getCollectionFields(collectionName, collections);
          this.setAttributes({
            selectedCollectionData: collection,
          });
          if (collection) {
            const finderOptions = [];
            collection.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            this.getTrait('finderUuid').set({ options: finderOptions });
            this.removeTrait('data-series');
            this.removeTrait('data-labels');
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collection);
            const fieldTraitTextContentOptions = await textTraitDateOptions(collection);
            this.addTrait({
              name: 'data-labels',
              label: 'Labels',
              options: fieldTraitTextContentOptions,
              title: `labels`,
              type: 'data-series-trait',
            });
            this.addTrait({
              name: 'data-series',
              label: 'Series Data',
              options: numberFieldTraitsOptions,
              title: `series-data`,
              type: 'data-series-trait',
            });
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:chartType', this.updateScript);
        this.listenTo(model, 'change:chartWidth', this.updateScript);
      },
    }),
  });
};
